export const errors = {
  captureMessage: (message, config) => {
    if (window.Raven) {
      window.Raven.captureMessage(message, config);
    }
  },
};
